/* eslint-disable import/no-anonymous-default-export */
export default {
  path: "/complaints",
  shortTitle: "Complaints",
  title: "Complaints and dispute resolution",
  category: "Orders and legal",
  summary: "A documented path for raising, reviewing and escalating an order, product, privacy or accessibility concern.",
  updated: "26 October 2026",
  sections: [
    {
      heading: "Start with customer care",
      body: [
        "Email the order number, relevant dates, product or page, a factual description, supporting photographs or messages, and the outcome sought. For privacy or accessibility matters, use a clear subject line. Do not send card numbers or original identity documents. Urgent safety concerns should say that use has stopped and identify any injury or property risk.",
      ],
    },
    {
      heading: "Review process",
      body: [
        "Customer care should acknowledge the complaint, identify any missing information, review the order and applicable policy, and give a reasoned response. Complex delivery traces, payment checks or product-safety reviews can require outside information. Because staffing and providers are not confirmed, the site does not promise an arbitrary response or resolution count of days; privacy data-access requests retain their statutory timing.",
      ],
    },
    {
      heading: "Possible resolutions",
      body: [
        "Depending on the facts and rights involved, outcomes may include explanation, correction of records or content, replacement, missing-part fulfilment, agreed return, cancellation, price reduction, refund, safety escalation or no action with reasons. A complaint will not be rejected merely because the item was discounted where mandatory rights apply.",
      ],
    },
    {
      heading: "Escalation and preserved rights",
      body: [
        "When an initial answer overlooks evidence, identify the specific omission in reply and request another review. Independent advice and an appropriate consumer, privacy, safety, payment or legal body remain available. The merchant has supplied no basis for imposing private arbitration, one exclusive forum, or a waiver of group or court remedies, so this page invents none. Protections that cannot be contracted away still stand.",
      ],
    },
  ],
};
